import { GridContainerProps } from "@insite/mobius/GridContainer";
import LoadingSpinner from "@insite/mobius/LoadingSpinner";
import React, { useEffect, useRef, useState } from "react";

interface LazyLoadWrapperProps {
    children: React.ReactNode;
    onVisible?: () => void;
    setIsVisible?: (visible: boolean) => void;
}

export interface LazyLoadWrapperStyles {
    mainContainer?: GridContainerProps;
}

export const lazyLoadWrapperStyles: LazyLoadWrapperStyles = {
    mainContainer: {
        style: {
            textAlign: "center",
        },
    },
}

const styles = lazyLoadWrapperStyles;

const LazyLoadWrapper: React.FC<LazyLoadWrapperProps> = ({ children, onVisible, setIsVisible }) => {
    const [isVisible, setIsVisibleState] = useState(false);
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting) {
                    setIsVisibleState(true);
                    setIsVisible?.(true); // Update visibility state
                    onVisible?.(); // Call the callback function here
                    observer.disconnect();
                }
            },
            { threshold: 0.1, rootMargin: "20px" }
        );

        if (ref.current) {
            observer.observe(ref.current);
        }

        return () => {
            if (ref.current) {
                observer.unobserve(ref.current);
            }
        };
    }, [onVisible, setIsVisible]);

    return <div ref={ref}>{isVisible ? children :
        <div {...styles.mainContainer}>
            <LoadingSpinner />
        </div>
    }</div>;
};


export default LazyLoadWrapper;